import { lazy } from "react"
import { Navigate } from "react-router-dom"

import { AUDITOR_BASE_ROLES_VALUES, COMPANY_BASE_ROLES_VALUES } from "@/shared/constants"
import type { CustomRoute } from "@/shared/types"

import { AdministrationWrapper } from "./wrapper/administration-wrapper"

const CompanyProfile = lazy(async () => import("@/pages/dashboard/administration/company-profile.tsx"))
const CompanyProfileEdit = lazy(async () => import("@/pages/dashboard/administration/company-profile-edit"))
const CompanyUsers = lazy(async () => import("@/pages/dashboard/administration/company-users.tsx"))

export const administrationRoutes: CustomRoute = {
  path: "administration",
  handle: {
    label: "Администрирование",
    i18Key: "administration",
    icon: "Settings",
    ignoreChildren: true,
    allowedRoles: [...COMPANY_BASE_ROLES_VALUES, ...AUDITOR_BASE_ROLES_VALUES]
  },
  element: <AdministrationWrapper />,
  children: [
    {
      index: true,
      element: <Navigate to="profile" replace />
    },
    {
      path: "profile",
      handle: {
        allowedPermissions: ["company_view", "company_change"]
      },
      children: [
        {
          index: true,
          Component: CompanyProfile
        },
        {
          path: "edit/:companyId",
          handle: {
            allowedPermissions: ["company_change", "company_view", "auditcompany_view", "auditcompany_change"]
          },
          Component: CompanyProfileEdit
        }
      ]
    },
    {
      path: "users",
      handle: {
        allowedPermissions: ["user_view", "user_change", "user_add"]
      },
      Component: CompanyUsers
    }
  ]
}
